import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import Meta from 'vue-meta'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    meta: {
      name: '',
      requiresAuth: true
    },
    redirect: {
      path: '/login'
    }
  },
  {
    path: '/login',
    meta: {
      name: 'Login',
      requiresAuth: false
    },
    component: () =>
      import(/* webpackChunkName: "Login" */ '../views/LoginHome.vue'),
      // redirect if already signed in
      beforeEnter: (to, from, next) => {
        if (store.getters.authorized) {
          next('/Home')
        } else {
          next()
        }
      },
    children: [{
      path: '',
      component: () => import(/* webpackChunkName: "LoginForm" */ '../components/LoginForm.vue')
    }]
  },
  {
    path: '/home',
    meta: {
      name: 'Home',
      requiresAuth: true,
    },
    component: Home,
    children: [
      {
          path: '',
          name: 'Principal',
          component: () => import('../views/Home.vue')
      },
    ]
  },
  {
    path: '/adminmesasexafinal',
    meta: {
        name: 'Administración de Mesas de Exámenes Finales',
        requiresAuth: true
    },
    component: () => import('../views/mesasexafinal/adminmesas.vue')
  },
  {
    path: '/inscripcioncarrera',
    meta: {
        name: 'Inscripción a Carrera',
        requiresAuth: true
    },
    component: () => import('../views/carrera/inscripcion.vue')
  },
  {
    path: '/matriculacion',
    meta: {
        name: 'Matriculación Anual',
        requiresAuth: true
    },
    component: () => import('../views/carrera/matriculacion.vue')
  },
  {
    path: '/inscripcioncursada',
    meta: {
        name: 'Inscripción a Cursadas',
        requiresAuth: true
    },
    component: () => import('../views/cursada/inscripcioncursada.vue')
  },
  {
    path: '/facturas',
    meta: {
        name: 'Facturas',
        requiresAuth: true
    },
    component: () => import('../views/comprobantes/facturas.vue')
  },
  {
    path: '/recibos',
    meta: {
        name: 'Recibos',
        requiresAuth: true
    },
    component: () => import('../views/comprobantes/recibos.vue')
  },
  {
    path: '/alumnocuota',
    meta: {
        name: 'Cuotas',
        requiresAuth: true
    },
    component: () => import('../views/alumno/cuotas.vue')
  },
  {
    path: '/importarpagofacil',
    meta: {
        name: 'Importar Archivo Pago Fácil',
        requiresAuth: true
    },
    component: () => import('../views/comprobantes/importarPagofacil.vue')
  },
  {
    path: '/reportedeudaxdivision',
    meta: {
        name: 'Reporte de Deuda por División',
        requiresAuth: true
    },
    component: () => import('../views/reportes/deudapordivision.vue')
  },
  {
    path: '/reportedeudaxcarrerasedeanio',
    meta: {
        name: 'Reporte de Deuda por Carrera Sede y Año',
        requiresAuth: true
    },
    component: () => import('../views/reportes/deudaporcarrerasedeycohorte.vue')
  },
  {
    path: '/listadocomprobantes',
    meta: {
        name: 'Reporte de Comprobantes',
        requiresAuth: true
    },
    component: () => import('../views/reportes/listadocomprobantes.vue')
  },
  {
    path: '/gestioncuota',
    meta: {
        name: 'Gestión de Cuotas',
        requiresAuth: true
    },
    component: () => import('../views/administracion/gestioncuota.vue')
  },
  {
    path: '/ficheroalumno',
    meta: {
        name: 'Fichero de Estudiantes',
        requiresAuth: true
    },
    component: () => import('../views/administracion/ficheroalumno.vue')
  },
  {
    path: '/asistenciaalumno',
    meta: {
        name: 'Asistencia de Estudiantes',
        requiresAuth: true
    },
    component: () => import('../views/cursada/asistenciaalumno.vue')
  },
  {
    path: '/adminmovimientoscc',
    meta: {
        name: 'Movimientos de CC de Estudiantes',
        requiresAuth: true
    },
    component: () => import('../views/administracion/adminmovimientos.vue')
  },
  {
    path: '/listadocursadas',
    meta: {
        name: 'Reporte de Cursadas',
        requiresAuth: true
    },
    component: () => import('../views/reportes/listadocursadas.vue')
  },
  {
    path: '/certificadoalumno',
    meta: {
        name: 'Certificados del Estudiante',
        requiresAuth: true
    },
    component: () => import('../views/reportes/certificadoalumno.vue')
  },
  {
    path: '/listadoalumnosdiv',
    meta: {
        name: 'Listado de Alumnos por División',
        requiresAuth: true
    },
    component: () => import('../views/reportes/listadoalumnosdivision.vue')
  },
  {
    path: '/notascursada',
    meta: {
        name: 'Notas de Cursada de Nivel Terciario',
        requiresAuth: true
    },
    component: () => import('../views/cursada/notascursada.vue')
  },
  {
    path: '/notascursadav2',
    meta: {
        name: 'Notas de Cursada de Nivel Terciario',
        requiresAuth: true
    },
    component: () => import('../views/cursada/notascursadav2.vue')
  },
  {
    path: '/informessecundario',
    meta: {
        name: 'Informes de Cursada de Nivel Secundario',
        requiresAuth: true
    },
    component: () => import('../views/cursada/informessecundario.vue')
  },
  {
    path: '/listadoasistenciaxalumno',
    meta: {
        name: 'Reporte de Asistencia por Alumno',
        requiresAuth: true
    },
    component: () => import('../views/reportes/listadoasistenciaxalumno.vue')
  },
  {
    path: '/listadofinalesrendidosxalumno',
    meta: {
        name: 'Reporte de Finales Rendidos por Alumno',
        requiresAuth: true
    },
    component: () => import('../views/reportes/listadofinalesrendidos.vue')
  },
  {
    path: '/inscmesas',
    meta: {
        name: 'Inscripción a Mesas de exámenes finales',
        requiresAuth: true
    },
    component: () => import('../views/mesasexafinal/inscripcionmesas.vue')
  },
  {
    path: '/pagosmatricula',
    meta: {
        name: 'Reporte de Pagos por Matrícula',
        requiresAuth: true
    },
    component: () => import('../views/reportes/pagosmatricula.vue')
  },
  {
    path: '/reporteinscripcionespracticas',
    meta: {
        name: 'Reporte de Inscripciones a Prácticas',
        requiresAuth: true
    },
    component: () => import('../views/reportes/reporteinscripcionespracticas.vue')
  },
  {
    path: '/asistenciaalumnosec',
    meta: {
        name: 'Asistencia de Estudiantes Nivel Secundario',
        requiresAuth: true
    },
    component: () => import('../views/cursada/asistenciaalumnosec.vue')
  },
  {
    path: '/listadoxperiodociclolectivoycurso',
    meta: {
        name: 'Reporte de Cursada x Periodo, Ciclo Lectivo y Curso',
        requiresAuth: true
    },
    component: () => import('../views/reportes/secundaria/listadoxperiodociclolectivoycurso.vue')
  },


//   {
//     path: '/listadosmatriculados',
//     meta: {
//       name: 'Listados de Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/ListadosMatriculados.vue')
//   },
//   {
//     path: '/ejercicioseconomicos',
//     meta: {
//       name: 'Ejercicios Económicos',
//       requiresAuth: true
//     },
//     component: () => import('../views/contabilidad/ejercicioseconomicos.vue')
//   },
//   {
//     path: '/adminpublicaciones',
//     meta: {
//       name: 'Ejercicios Económicos',
//       requiresAuth: true
//     },
//     component: () => import('../views/biblioteca/adminpublicaciones.vue')
//   },
//   {
//     path: '/adminmatriculados',
//     meta: {
//       name: 'Fichero Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/AdminMatriculados.vue')
//   },
//   {
//     path: '/tramitesmatriculas',
//     meta: {
//       name: 'Trámites de Matrícula',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/TramitesMatriculas.vue')
//   },
//   {
//     path: '/cuotaanual',
//     meta: {
//       name: 'Cuota Anual',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/CuotaAnual.vue')
//   },
//   {
//     path: '/recibos',
//     meta: {
//       name: 'Recibos de Tesorería',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/Recibos.vue')
//   },
//   {
//     path: '/deudamatriculados',
//     meta: {
//       name: 'Carga Deuda de Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/DeudaMatriculado.vue')
//   },
//   {
//     path: '/conveniopago',
//     meta: {
//       name: 'Convenio de Pago - Sentencia Judicial',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/ConvenioPago.vue')
//   },
//   {
//     path: '/depositos',
//     meta: {
//       name: 'Depósitos Bancarios',
//       requiresAuth: true
//     },
//     component: () => import('../views/banco/Depositos.vue')
//   },
//   {
//     path: '/extracciones',
//     meta: {
//       name: 'Extracciones Bancarias',
//       requiresAuth: true
//     },
//     component: () => import('../views/banco/Extracciones.vue')
//   },
//   {
//     path: '/transferencias',
//     meta: {
//       name: 'Transferencias Bancarias',
//       requiresAuth: true
//     },
//     component: () => import('../views/banco/Transferencias.vue')
//   },
//   {
//     path: '/comvendolares',
//     meta: {
//       name: 'Compra/Venta de Dólares',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/CompraVentaDolares.vue')
//   },
//   {
//     path: '/cobroventacheques',
//     meta: {
//       name: 'Cobro/Venta de Cheques en Cartera',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/CobroVentaChequesenCartera.vue')
//   },
//   {
//     path: '/planillacaja',
//     meta: {
//       name: 'Planilla de Caja',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/PlanillaCaja.vue')
//   },
//   {
//     path: '/ordenpago',
//     meta: {
//       name: 'Órdenes de Pago',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/OrdenPago.vue')
//   },
//   {
//     path: '/compras',
//     meta: {
//       name: 'Comprobantes de Compras',
//       requiresAuth: true
//     },
//     component: () => import('../views/compras/Compras.vue')
//   },
//   {
//     path: '/imputacomp',
//     meta: {
//       name: 'Imputar Comprobantes de Compra',
//       requiresAuth: true
//     },
//     component: () => import('../views/compras/ImputaComprobantes.vue')
//   },
//   {
//     path: '/tramitesmorosidad',
//     meta: {
//       name: 'Trámites de Morosidad',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/TramiteMorosidad.vue')
//   },
//   {
//     path: '/adminpersonas',
//     meta: {
//       name: 'Administración de Personas',
//       requiresAuth: true
//     },
//     component: () => import('../views/administracion/adminpersonas.vue')
//   },
//   {
//     path: '/adminactacademicas',
//     meta: {
//       name: 'Administración de Act. Académicas',
//       requiresAuth: true
//     },
//     component: () => import('../views/academica/adminactividadesacademicas.vue')
//   },
//   {
//     path: '/infsaldosmatriculados',
//     meta: {
//       name: 'Informe de Saldos de Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/InformeSaldosMatriculados.vue')
//   },
//   {
//     path: '/infantsaldoscc',
//     meta: {
//       name: 'Informe de Antigüedad de Saldos de Cuenta Corriente',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/InformeAntiguedadSaldosCC.vue')
//   },
//   {
//     path: '/infmovmatriculados',
//     meta: {
//       name: 'Informe de Movimientos por Matriculado',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/InformeMovimientosMatriculado.vue')
//   },
//   {
//     path: '/infvencdebmatriculado',
//     meta: {
//       name: 'Informe de Vencimientos de Débitos de Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/InformeVencimDebitosMatriculado.vue')
//   },
//   {
//     path: '/infvencproveedores',
//     meta: {
//       name: 'Informe de Vencimientos de Proveedores',
//       requiresAuth: true
//     },
//     component: () => import('../views/compras/InformeVencimientoProveedores.vue')
//   },
//   {
//     path: '/infmovimproveedores',
//     meta: {
//       name: 'Informe de Movimientos de Proveedores',
//       requiresAuth: true
//     },
//     component: () => import('../views/compras/InformeMovimientosProveedores.vue')
//   },
//   {
//     path: '/infsaldosccproveedores',
//     meta: {
//       name: 'Informe de Saldos de Cuenta Corriente de Proveedores',
//       requiresAuth: true
//     },
//     component: () => import('../views/compras/InformeSaldosCCProveedores.vue')
//   },
//   {
//     path: '/admincuentasbancarias',
//     meta: {
//       name: 'Administrador de Cuentas Bancarias',
//       requiresAuth: true
//     },
//     component: () => import('../views/administracion/admincuentasbancarias.vue')
//   },
//   {
//     path: '/certificadomatricula',
//     meta: {
//       name: 'Administrador de Cuentas Bancarias',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/CertificadoMatricula.vue')
//   },
//   {
//     path: '/notaentrada',
//     meta: {
//       name: 'Notas de Entrada',
//       requiresAuth: true
//     },
//     component: () => import('../views/administrativo/notaentrada.vue')
//   },
//   {
//     path: '/notasalida',
//     meta: {
//       name: 'Notas de Entrada',
//       requiresAuth: true
//     },
//     component: () => import('../views/administrativo/notasalida.vue')
//   },
//   {
//     path: '/tasamix',
//     meta: {
//       name: 'Tasa Mix',
//       requiresAuth: true
//     },
//     component: () => import('../views/tesoreria/TasaMix.vue')
//   },
//   {
//     path: '/consultamatriculados',
//     meta: {
//       name: 'Consulta de Matriculados',
//       requiresAuth: true
//     },
//     component: () => import('../views/matriculados/ConsultaMatriculados.vue')
//   },
//   {
//     path: '/bibliotecaprestamos',
//     meta: {
//       name: 'Prestamos de Publicaciones',
//       requiresAuth: true,
//     },
//     component: () => import(/* webpackChunkName: "prestamo" */ '../views/biblioteca/prestamo.vue')
//   },
//   {
//     path: '/bibliotecadevoluciones',
//     meta: {
//       name: 'Devoluciones de Publicaciones',
//       requiresAuth: true,
//     },
//     component: () => import(/* webpackChunkName: "devolucion" */ '../views/biblioteca/devolucion.vue')
//   },
//   {
//     path: '/adminusuarios',
//     meta: {
//       name: 'Administración de Usuarios',
//       requiresAuth: true,
//     },
//     component: () => import(/* webpackChunkName: "adminusuarios" */ '../views/seguridad/adminusuarios.vue')
//   },
//   {
//     path: '/actasres/:id',
//     meta: {
//       name: 'Actas y Resoluciones del Consejo Directivo',
//       requiresAuth: true,
//     },
//     component: () => import(/* webpackChunkName: "actasyresconsejo" */ '../views/administrativo/actasyresconsejo.vue')
//   },
//   {
//     path: '/infmovcuentasbancarias/:id',
//     meta: {
//       name: 'Informes Bancarios',
//       requiresAuth: true,
//     },
//     component: () => import(/* webpackChunkName: "actasyresconsejo" */ '../views/banco/InformeMovCuentasBancarias.vue')
//   },
//   {
//     path: '/matriculado/:id',
//     meta: {
//       name: 'Matriculado',
//       requiresAuth: false,
//     },
//     component: () => import(/* webpackChunkName: "matriculado" */ '../views/publico/Matriculado.vue')
//   }
]

const router = new VueRouter({
  base: '',
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authorized) {
      next()
      return
    }else{
      next('/login')
    }
  } else {
    next()
  }
})

Vue.use(Meta)

export default router
